export default "__VITE_ASSET__C8fCgbeB__"